export default __webpack_public_path__ + "66936ba07b1c4aeb4d0d68f4681383bb.png";